import { memo } from 'react';

import type { SVGProps } from 'react';
const SvgIconBadgeValidatedThick = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 103 103"
    role="img"
    className={props.className}
    {...props}
  >
    <circle cx={51.5} cy={51.5} r={50.75} fill="#C88245" stroke="#904C06" strokeWidth={1.5} />
    <path fill="#C3782C" d="M51.5 101.5c27.614 0 50-22.386 50-50s-22.386-50-50-50z" />
    <path
      stroke="#914C06"
      strokeWidth={1.5}
      d="M81.5 43.692 51.5 21.5l-30 21.37v16.438m60-15.616V60.13l-30 21.37-30-22.192m60-15.616-30 22.192-19.714-14.466M21.5 59.308l10.286-7.89m40.285-.329L51.5 36.295 31.786 51.418"
    />
  </svg>
);
const Memo = memo(SvgIconBadgeValidatedThick);
export default Memo;
